import { SxProps, styled } from '@cp/ds/src/theme';
import React, { ChangeEventHandler, PropsWithChildren } from 'react';
import { Tokens, name } from './const';

const TariffRoot = styled('label', { name })(({ theme }) => ({
  userSelect: 'none',
  cursor: 'pointer',
  borderRadius: '12px',
  position: 'relative',
  transition: theme.transitions.create(['box-shadow'], {
    duration: theme.transitions.duration.short,
  }),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  overflow: 'hidden',
  outlineColor: Tokens.BorderColor(),
  backgroundColor: Tokens.RootBG(),
  boxShadow: Tokens.Shadow(),
  minWidth: 140,
  paddingBottom: theme.spacing(1.75),
  gap: theme.spacing(1),
  textAlign: 'center',
  '&:has(input[checked])': {
    outline: '2px solid ' + Tokens.BorderColorChecked(Tokens.BorderColor()),
    boxShadow: Tokens.ShadowChecked(),
  },
}));

export interface TariffProps extends PropsWithChildren {
  sx?: SxProps;
  selected?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  name?: string;
  value: number | string;
}
// eslint-disable-next-line @typescript-eslint/no-shadow
export const Tariff: React.FC<TariffProps> = ({ selected, onChange, value, name, children, ...props }) => {
  return (
    <TariffRoot {...props}>
      <input defaultChecked={selected} name={name} onChange={onChange} style={{ display: 'none' }} type="radio" value={value} />
      {children}
    </TariffRoot>
  );
};
Tariff.displayName = name;
